import { useMessageToState } from "./useMessageToState";

const getDefinition = (editor: eXpress.core.IEditor) => editor.definition;

/**
 * Returns the current definition, and trigger a re-render when a new definition is set.
 */
export function useDefinition() {
	return useMessageToState({
		name: "useDefinition",
		filterMessage: eXpress.core.isNewDefinitionLoaded,
		getState: getDefinition,
	});
}
